import React from "react";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import {request} from "../../../api-client";
import Popper from "@material-ui/core/Popper";
import IconButton from "@material-ui/core/IconButton";
import BloomSpinner from "../../../assets/img/bloom_spinner_grey.gif";
import PlaylistAdd from "@material-ui/icons/PlaylistAdd";
import AddIcon from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Clear from '@material-ui/icons/Clear';
import Done from '@material-ui/icons/Done';
import localization from "../../../config/localization";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../Snackbar/GlobalSnackbar";
import {homePathGenerator} from "../../../api-client/core/authentication/utils";
import Link from "react-router-dom/Link";
import browserHistory from "../../../utils/browserHistory";

class AddToPlaylist extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      type: null,
      selectedTrack: null,
      open: false,
      requesting: true,
      newPlaylist: "",
      addingPlaylist: false,
      playlists: [],
      availablePlaylists: [],
      search: "",
    }
  }

  show = () => 
    request.playlist.getAllForHome()
      .then(response => {
        this.setState({
          open: true,
          playlists: response,
          requesting: false,
          availablePlaylists: response,
          search: ""
        })
      })

  handleClose = () =>
    this.setState({
      open: false,
      playlists: [],
      requesting: false,
      availablePlaylists: [],
      search: "",
      addingPlaylist: false,
    })

  addNewPlaylist = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({newPlaylist: this.state.search}, () => this.setState({addingPlaylist: true}))
  }

  handleToggle = (e) => {
    e.preventDefault()
    e.stopPropagation()
    !this.state.open ? this.show() : this.handleClose()
  }

  storeNewPlaylist = () => request.playlist.create({title: this.state.newPlaylist, visibility: false})
    .then(() => {
      GlobalSnackbar.show({
        message: localization.get("navbar.playlist_created"),
        type: GlobalSnackbarTypes.SUCCESS,
      })
    })
    .then(() => this.setState({newPlaylist: "", addingPlaylist: false}, this.show))

  addToPlaylist = (playlist, contentId, contentType) =>  request.playlist.addToPlaylist({
    playlistId: playlist.id,
    contentId,
    contentType
  })
    .then(() => {
      GlobalSnackbar.show({
        message: <span>{localization.get(this.props.content == "contentCreation" ? "playlist.add_content" : "playlist.add_profile")} <Link
          style={{color: "white", textDecoration: "underline"}}
          to={homePathGenerator(`playlist/${playlist.id}`)}
          onClick={() => browserHistory.push(homePathGenerator(`playlist/${playlist.id}`))}><span style={{color: "white",textDecoration: "underline"}}>{playlist.title}</span>
        </Link></span>,
        type: GlobalSnackbarTypes.SUCCESS,
        place: "bc"
      })
    })
    .then(this.handleClose)

  render() {
    const {playlists, availablePlaylists, open, requesting, newPlaylist, addingPlaylist, search} = this.state
    const {id, content, icon} = this.props
    return (
      <>
        <div
          aria-describedby={id}
          ref={node => this.anchorEl = node}
          aria-owns={open ? "menu-list-grow" : null}
          aria-haspopup="true"
          onClick={this.handleToggle}
        >
          {icon || <PlaylistAdd/>}
        </div>
        <Popper
          open={open}
          id={id}
          anchorEl={this.anchorEl}
          transition
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          style={{zIndex:1400}}
        >
          {({TransitionProps, placement}) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{transformOrigin: "center right", zIndex:10}}
            >
              <Paper style={this.props.creationPlayer ? {zIndex:10, marginLeft: 74} : {zIndex:10}}>
                <ClickAwayListener onClickAway={this.handleClose}>
                  {requesting ?
                    <img style={{width: 50, height: 50}} src={BloomSpinner} alt="Loading logo"/>
                    :
                    <MenuList style={this.props.creationPlayer ? {paddingBottom: 0, paddingTop: 0, minWidth: 224, width: 224} : {paddingBottom: 0, paddingTop: 0, minWidth: 250}}>
                      <MenuItem
                        style={{cursor: "default"}}
                        onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}>
                        <div style={{
                          border: "1px solid #ccc",
                          borderRadius: 30,
                          backgroundColor: "rgba(255, 255, 255, 0)",
                          position: "relative",
                          float: "left",
                          width: "100%",
                        }}>
                          <Search style={{marginBottom: -8, padding: 3}}/>
                          <input
                            onChange={event => this.setState({
                              search: event.target.value,
                              availablePlaylists: playlists.filter(i =>
                                i.title.toLowerCase().includes(event.target.value.toLowerCase())
                              )
                            })}
                            value={search}
                            style={{border: "none", backgroundColor:  "transparent"}}
                            placeholder={localization.get('home.smart_search.search_playlist')}
                            onClick={e => {
                              e.preventDefault()
                              e.stopPropagation()
                            }}
                          />
                        </div>
                      </MenuItem>
                      {availablePlaylists.map((playlist, index) => {
                        if(index < 3) return (
                          <MenuItem onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            this.addToPlaylist(playlist, id, content)
                          }} style={{cursor: "pointer"}}>
                            {playlist.title}
                          </MenuItem>)
                        }
                      )}
                      {!addingPlaylist ?
                        <MenuItem style={{cursor: "pointer", background:"#ccc"}} onClick={this.addNewPlaylist}>
                          <strong>{localization.get('playlists.create')}</strong>
                          <AddIcon style={{cursor: "pointer", padding: 3}} />
                        </MenuItem>
                        :
                        <MenuItem style={{cursor: "default"}}
                          onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}>
                          <input
                            onChange={event => this.setState({newPlaylist: event.target.value})}
                            value={newPlaylist}
                            style={{border: "none", height: 30, width: "100%"}}
                            placeholder={localization.get('playlist.add_new')}
                            onKeyPress={e => {
                              e.key == "Enter" && newPlaylist.length > 0 && this.storeNewPlaylist()
                              e.key == "Escape" && this.setState({newPlaylist: "", addingPlaylist: false})
                            }}
                            onClick={e => {
                              e.preventDefault()
                              e.stopPropagation()
                            }}
                          />
                          <Done style={{cursor: "pointer", color: "green"}} onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            newPlaylist.length > 0 && this.storeNewPlaylist()
                          }}/>
                          <Clear style={{cursor: "pointer"}} onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            this.setState({newPlaylist: "", addingPlaylist: false})
                          }}/>
                        </MenuItem>
                      }
                    </MenuList>
                  }
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    )}
}

export default AddToPlaylist
